import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FilePng"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 17.25H18C17.1716 17.25 16.5 16.5784 16.5 15.75V8.25C16.5 7.42157 17.1716 6.75 18 6.75H22.5V8.25H18V15.75H21V12.75H19.5V11.25H22.5V17.25ZM13.5 14.25L10.74 6.75H9V17.25H10.5V9.75L13.26 17.25H15V6.75H13.5V14.25ZM3 17.25H1.5V6.75H6C6.82843 6.75 7.5 7.42157 7.5 8.25V12C7.5 12.8284 6.82843 13.5 6 13.5H3V17.25ZM3 12H6V8.25H3V12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FilePng.vue"]]);
